export default "__VITE_ASSET__7922e97f__"